<template functional>
  <div class="lazy-loading-spinner">
    <BarLoader
      class="lazy-loading-spinner__spinner"
      color="#ef7d22"
      :size="10"
      sizeUnit="px"
    />
  </div>
</template>

<script>
import { BarLoader } from '@saeris/vue-spinners'

export default {
  name: 'LazyLoadingSpinner',
  components: {
    BarLoader,
  },
}
</script>

<style lang="scss" scoped>
.lazy-loading-spinner {
  display: inline-block;
  position: relative;
  vertical-align: middle;
  background-color: transparent;
  width: 100%;
  margin: 0 auto;
  margin-top: 3rem;
  margin-bottom: 3rem;
  text-align: center;
  &__spinner {
    margin: 0 auto;
  }
}
</style>
